var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 3V0L2.25 3.75L6 7.5V4.5C8.4825 4.5 10.5 6.5175 10.5 9C10.5 11.4825 8.4825 13.5 6 13.5C3.5175 13.5 1.5 11.4825 1.5 9H0C0 12.315 2.685 15 6 15C9.315 15 12 12.315 12 9C12 5.685 9.315 3 6 3Z",
    fill: "#14151C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.871a6a829820e60aa47f8e2f0925b321.svg";
export { ForwardRef as ReactComponent };